<template>
<div v-can="'Read_Material'">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <h1 class="text-left">{{$tc('general.material', 2)}}</h1>
        <MainGrid :gridTitle="$tc('general.material', 2)" objectNodeName="entityModels" endpoint="material" :gridColumns="columns" :filter="filter" :customOrderBy="true" formUrl="/material" :queryByFilter="true" deletedataToDisplay="tradeName" :deleteAssociatedData="$store.state.material.associatedData" :deleteEndpointToDelete="$store.state.material.endpointToDelete"></MainGrid>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import MainGrid from '../components/MainGrid'

export default {
  name: 'MaterialGrid',
  components: {
    MainGrid
  },
  data() {
    return {
      title: 'Raw Materials',
      columns: [
        {
          label: this.$t('material.materialId'),
          key: "prefixId",
          sortable: true,
        },
        {
          label: this.$t('material.tradeName'),
          key: "tradeName",
          sortable: true,
        },
        {
          label: this.$t('material.location'),
          key: "location",
          sortable: true,
        },
        {
          label: this.$t('material.families'),
          key: "familiesName",
          sortable: true,
        },
        {
          label: this.$t('distributor.distributorName'),
          key: "distributorName",
          sortable: true,
        },
        {
          label: this.$t('general.status'),
          key: "status",
          sortable: true,
        },
        {
          key: "actionButtons",
          label: "",
        }
      ],
      filter: [{
        method: "findByMaterialIngredientInciDistributor",
        params: ["searchValue"]
      }]
    }
  }
}
</script>

<style>
.btn-icon{
  cursor: pointer;
  margin: 0px 5px;
}

</style>
